<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Configurazioni', route: '/backoffice/configurazioni/' }, { label: 'Aggiungi Configurazione', route: '/backoffice/configurazioni/add' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">AGGIUNGI CONFIGURAZIONE</h1>
</section>

<section class="pb-16 mb-8 px-container"> 
    <form [formGroup]="formConfigurazione" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">                                                                
            <div class="w-full">
                <label>* Valore</label>
                <input type="text" pInputText formControlName="value" name="value" id="value" required />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formConfigurazione.get('value')?.hasError('required') && (formConfigurazione.get('value')?.dirty || formConfigurazione.get('value')?.touched)">Il valore è obbligatorio!.</small>
            </div>                                                                     
            <div class="w-full">
                <label>Descrizione <i>(opzionale)</i></label>
                <input type="text" pInputText formControlName="descrizione" name="descrizione" id="descrizione" />
            </div>                
            <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formConfigurazione.valid">Aggiungi</button>
        </div>
    </form>
</section>